export const REQUEST_FETCH_ENTITY_AD = "REQUEST_FETCH_ENTITY_AD";
export const FETCH_ENTITY_AD_SUCCESS = "FETCH_ENTITY_AD_SUCCESS";
export const FETCH_ENTITY_AD_FAILURE = "FETCH_ENTITY_AD_FAILURE";

export const CLEAR_FETCH_ENTITY_AD_STATES = "CLEAR_FETCH_ENTITY_AD_STATES";
